const getBaseUrl = () => {
  switch (process.env.REACT_APP_ENV || 'development') {
    case 'development':
      return 'https://staging-vbg.gs1eg.org';
    case 'staging':
      return 'https://staging-vbg.gs1eg.org';
    case 'production':
      return 'https://vbg.gs1eg.org';
    default:
      return 'https://staging-vbg.gs1eg.org';
  }
};

export const API_BASE_URL = getBaseUrl();
